(() => {
	'use strict';

	const bodyOpenClass = 'fxy-gs-dialog-open';
	let activeTrigger = null;

	const closeDialog = (dialog) => {
		if (!dialog || !dialog.open) return;
		dialog.close();
	};

	const openDialog = (dialog, trigger) => {
		if (!dialog) return;
		activeTrigger = trigger;

		if (typeof dialog.showModal === 'function') {
			dialog.showModal();
			document.body.classList.add(bodyOpenClass);
			const close = dialog.querySelector('[data-fxy-gs-close]');
			if (close) close.focus();
			return;
		}

		dialog.setAttribute('open', '');
		document.body.classList.add(bodyOpenClass);
	};

	document.addEventListener('click', (event) => {
		const trigger = event.target.closest('[data-fxy-gs-dialog]');
		if (trigger) {
			event.preventDefault();
			openDialog(document.getElementById(trigger.dataset.fxyGsDialog), trigger);
			return;
		}

		const close = event.target.closest('[data-fxy-gs-close]');
		if (close) {
			event.preventDefault();
			closeDialog(close.closest('[data-fxy-gs-modal]'));
		}
	});

	document.addEventListener('click', (event) => {
		const dialog = event.target.closest('[data-fxy-gs-modal]');
		if (dialog && event.target === dialog) {
			closeDialog(dialog);
		}
	});

	document.addEventListener('close', (event) => {
		if (!event.target.matches('[data-fxy-gs-modal]')) return;
		document.body.classList.remove(bodyOpenClass);
		if (activeTrigger) activeTrigger.focus();
		activeTrigger = null;
	}, true);

	document.querySelectorAll('[data-fxy-gs]').forEach((widget) => {
		const track = widget.querySelector('[data-fxy-gs-track]');
		const slides = Array.from(widget.querySelectorAll('[data-fxy-gs-slide]'));
		const dots = Array.from(widget.querySelectorAll('[data-fxy-gs-dot]'));
		const prev = widget.querySelector('[data-fxy-gs-prev]');
		const next = widget.querySelector('[data-fxy-gs-next]');

		if (!track || !slides.length) return;

		widget.classList.add('fxy-gs--is-enhanced');
		let activeIndex = 0;
		let maxReachableIndex = slides.length - 1;

		const getSlideLeft = (slide) => slide.offsetLeft - track.offsetLeft;

		const getReachableMaxIndex = () => {
			const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
			const tolerance = 2;
			let index = 0;

			slides.forEach((slide, slideIndex) => {
				if (getSlideLeft(slide) <= maxScrollLeft + tolerance) {
					index = slideIndex;
				}
			});

			return Math.max(0, index);
		};

		const getBoundedIndex = (index) => Math.max(0, Math.min(index, maxReachableIndex));

		const syncReachableDots = () => {
			maxReachableIndex = getReachableMaxIndex();

			dots.forEach((dot, dotIndex) => {
				const isReachable = dotIndex <= maxReachableIndex;
				dot.hidden = !isReachable;
				dot.setAttribute('aria-hidden', isReachable ? 'false' : 'true');
			});

			if (activeIndex > maxReachableIndex) setActive(maxReachableIndex);
		};

		const setActive = (index) => {
			activeIndex = getBoundedIndex(index);

			dots.forEach((dot, dotIndex) => {
				dot.classList.toggle('is-active', dotIndex === activeIndex);
				dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
			});

			if (prev) prev.disabled = activeIndex === 0;
			if (next) next.disabled = activeIndex === maxReachableIndex;
		};

		const scrollToIndex = (index) => {
			const targetIndex = getBoundedIndex(index);
			const slide = slides[targetIndex];

			if (!slide) return;

			setActive(targetIndex);
			track.scrollTo({
				behavior: 'smooth',
				left: slide.offsetLeft - track.offsetLeft,
			});
		};

		const updateActiveFromScroll = () => {
			const current = slides.slice(0, maxReachableIndex + 1).reduce((closest, slide, index) => {
				const distance = Math.abs(getSlideLeft(slide) - track.scrollLeft);

				return distance < closest.distance ? {distance, index} : closest;
			}, {distance: Number.POSITIVE_INFINITY, index: 0});

			setActive(current.index);
		};

		dots.forEach((dot, index) => {
			dot.addEventListener('click', () => scrollToIndex(index));
		});

		if (prev) {
			prev.addEventListener('click', () => {
				scrollToIndex(activeIndex - 1);
			});
		}

		if (next) {
			next.addEventListener('click', () => {
				scrollToIndex(activeIndex + 1);
			});
		}

		let scrollFrame = null;
		track.addEventListener('scroll', () => {
			if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
			scrollFrame = window.requestAnimationFrame(updateActiveFromScroll);
		}, {passive: true});

		window.addEventListener('resize', () => {
			syncReachableDots();
			updateActiveFromScroll();
		});

		syncReachableDots();
		setActive(0);
	});
})();
